import styled from 'styled-components';

export const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 16px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
    min-height: 160px;
    height: 100%;
`;

export const MetricTitle = styled.div`
    font-family: 'Roboto', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
    text-align: center;
    color: #25272e;
    margin-bottom: 12px;
`;

export const MetricValueWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: end;
    width: 100%;
`;

export const MetricValue = styled.div`
    grid-column: 2;
    font-weight: 900;
    font-size: 28px;
    line-height: 100%;
    color: #25272e;
    text-align: center;

    span {
        font-size: 20px;
        margin-left: 4px;
    }
`;

export const MetricGoal = styled.div`
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    text-align: center;
    color: #7c8187;
    margin-top: 12px;
`;

export const PercentageContainer = styled.div`
    grid-column: 3;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 600;
    justify-self: start;
    margin-left: 8px;
`;

export const PercentageText = styled.span`
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: ${(props) => (props.isAboveGoal ? '#62C054' : '#E74C3C')};
`;
